import { render, staticRenderFns } from "./CaseFilters.vue?vue&type=template&id=53932643&scoped=true&"
import script from "./CaseFilters.vue?vue&type=script&lang=ts&"
export * from "./CaseFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53932643",
  null
  
)

export default component.exports